/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';

// import styles from '../../comunities-solicitudes-pendiente-list-page-new-onboarding-detalle.module.scss'; // ajusta si lo mueves
import { SectionTitle } from 'components';
import { renderDocumentViewer } from '../../renderDocumentViewer';
import styles from './documentos.module.scss';

interface DocumentosProps {
  docsFactura: { id: string; documento: string; nombre: string; tipo: string }[];
  docsDNIFront: { id: string; documento: string; nombre: string; tipo: string }[];
  docsDNIBack: { id: string; documento: string; nombre: string; tipo: string }[];
  actualizarImagenPorTipo: (tipo: string, src: string, index: number) => void;
  imagenSeleccionada: {
    [tipo: string]: { src: string; index: number };
  };
}

const Documentos = ({
  docsFactura,
  docsDNIBack,
  docsDNIFront,
  actualizarImagenPorTipo,
  imagenSeleccionada,
}: DocumentosProps) => (
  <div className={styles.documentContainer}>
    {/* FACTURA */}
    <div className={styles.documentSection}>
      <SectionTitle text={I18n.t('factura')} />
      {docsFactura.length > 0 ? (
        renderDocumentViewer(
          docsFactura,
          I18n.t('factura'),
          (src, i) => actualizarImagenPorTipo('FACTURA', src, i),
          imagenSeleccionada.FACTURA?.src,
          imagenSeleccionada.FACTURA?.index,
        )
      ) : (
        <p className={styles.emptyText}>{I18n.t('noFacturas')}</p>
      )}
    </div>

    {/* DNI FRONT */}
    <div className={styles.documentSection}>
      <SectionTitle text={I18n.t('dniFront')} />

      {docsDNIFront.length > 0 ? (
        renderDocumentViewer(
          docsDNIFront,
          I18n.t('dniFront'),
          (src, i) => actualizarImagenPorTipo('DNI_FRONT', src, i),
          imagenSeleccionada.DNI_FRONT?.src,
          imagenSeleccionada.DNI_FRONT?.index,
        )
      ) : (
        <p className={styles.emptyText}>{I18n.t('noDNIFront')}</p>
      )}
    </div>

    {/* DNI BACK */}
    <div className={styles.documentSection}>
      <SectionTitle text={I18n.t('dniBack')} />

      {docsDNIBack.length > 0 ? (
        renderDocumentViewer(
          docsDNIBack,
          I18n.t('dniBack'),
          (src, i) => actualizarImagenPorTipo('DNI_BACK', src, i),
          imagenSeleccionada.DNI_BACK?.src,
          imagenSeleccionada.DNI_BACK?.index,
        )
      ) : (
        <p className={styles.emptyText}>{I18n.t('noDNIBack')}</p>
      )}
    </div>
  </div>
);

export default Documentos;
